import React from 'react'
import Navbar from "../inc/Navbar";
import { Link } from "react-router-dom";



function About() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
            <br />
<br/>
            <div className='colorback'>
                <div className="album py-1">

                    <div className="container mt-3">

                        <div className="row">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li style={{ color: "Darkblue" }} className="breadcrumb-item"><Link style={{ color: "Darkblue" }} to="/" > HOME</Link></li>


                                    <li className="breadcrumb-item active" aria-current="page">ABOUT US</li>

                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="album py-1">
                <div className="container">

                    <h1 className='mb-4'><b>About LipoKart</b></h1>
                    <h6 className='justify mb-2'>Welcome to LipoKart, your trusted partner in innovative and high-quality products designed to simplify your life. Whether you're a farmer looking for reliable machinery, a homeowner in search of stunning décor, or a gardening enthusiast seeking the best tools, we’ve got you covered.</h6>
                    <h6 className='justify mb-2'>Our mission is to provide top-quality products at competitive prices, ensuring that our customers get value for their money. We pride ourselves on exceptional customer service and a seamless shopping experience, whether you're a seasoned professional or a first-time buyer.</h6>
                    <p className='justify'>With LipoKart, you’ll find more than just products—you’ll find solutions that empower your work, enhance your lifestyle, and bring your creative visions to life.</p>
                </div>
            </div>
<br/>

        </div>
    )
}

export default About